import React, { FC } from 'react';

interface PaymentInfoItemProps {
  title: string;
  content: string;
  className?: string;
}

export const PaymentInfoItem: FC<PaymentInfoItemProps> = ({
  title,
  content,
  className,
}) => {
  return (
    <div className={`${className} flex justify-between items-center text-13 `}>
      <p className="text-gray-500">{title}</p>
      <p className="t">{content}</p>
    </div>
  );
};
